import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ResourceBundleService } from '@app/services/resource-bundle/resource-bundle.service';
import { find, get } from 'lodash-es';

@Component({
    selector: 'pixie-stories',
    templateUrl: './stories.component.html',
    styleUrls: ['./stories.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class StoriesComponent implements OnInit {
    siteId = 'dcl';
    desktopOrMobile = 'desktop';
    storyOrder;
    stories: any[];

    constructor(private resourceBundle: ResourceBundleService) { }

    ngOnInit() {
        this.resourceBundle.get('stories').then(data => {
          this.storyOrder = data.storyOrderingPreset[this.desktopOrMobile];
          this.stories = data.stories;
        });
    }

}
